import { useEffect } from 'react';

/**
 * Hook personalizado para implementar Google Tag Manager en una aplicación React
 * @param {string} gtmId - El ID de Google Tag Manager (formato: 'GTM-XXXXXX')
 */
function useGoogleTagManager(gtmId) {
  useEffect(() => {
    if (!gtmId) {
      console.warn('No se proporcionó un ID de Google Tag Manager');
      return;
    }

    // Función para insertar el script en el head
    const insertGtmScript = () => {
      // Crear el script para el head
      const scriptElement = document.createElement('script');
      const scriptContent = `
        (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
        new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
        j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
        'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
        })(window,document,'script','dataLayer','${gtmId}');
      `;
      
      scriptElement.innerHTML = scriptContent;
      
      // Insertar al inicio del head
      const headElement = document.getElementsByTagName('head')[0];
      headElement.insertBefore(scriptElement, headElement.firstChild);
    };

    // Función para insertar el noscript después de la apertura del body
    const insertGtmNoScript = () => {
      // Crear el noscript para el body
      const noScriptElement = document.createElement('noscript');
      const iframeElement = document.createElement('iframe');
      
      iframeElement.src = `https://www.googletagmanager.com/ns.html?id=${gtmId}`;
      iframeElement.height = '0';
      iframeElement.width = '0';
      iframeElement.style.display = 'none';
      iframeElement.style.visibility = 'hidden';
      
      noScriptElement.appendChild(iframeElement);
      
      // Insertar justo después de la apertura del body
      const bodyElement = document.body;
      bodyElement.insertBefore(noScriptElement, bodyElement.firstChild);
    };

    // Ejecutar ambas funciones
    insertGtmScript();
    insertGtmNoScript();

    // Cleanup function (opcional)
    return () => {
      // Si necesitas limpiar algo cuando el componente se desmonte
      // Puedes implementarlo aquí
    };
  }, [gtmId]); // Solo se ejecuta cuando cambia el gtmId
}

export default useGoogleTagManager;